export default __webpack_public_path__ + "static/media/Valeria_Perez_Reale.cc56b1e4.png";